import { createAsyncThunk } from "@reduxjs/toolkit";
import apiAxios from "../../../services/apiAxios";
import {
  setError,
  setAdminDetails,
} from "../../Reducer/AdminAccount/AccountSlice";
import { setCustomers, setLoading } from "../../Reducer/Customer/CustomerSlice";

export const getAdminDetails = createAsyncThunk(
  "store/getAdminDetails",
  async (token, { dispatch }) => {
    dispatch(setLoading(true));
    try {
      const response = await apiAxios.get("api/auth/admin/get-admin-detail");
      dispatch(setAdminDetails(response.data));
      dispatch(setLoading(false));
    } catch (error) {
      dispatch(setError(error.toString()));
      dispatch(setLoading(false));
    }
  }
);

export const getCustomerList = createAsyncThunk(
  "store/getCustomerList",
  async ({ page, limit }, { dispatch }) => {
    dispatch(setLoading(true));
    try {
      const response = await apiAxios.get(
        `api/auth/get-all-patients?page=${page}&limit=${limit}`
      );
      dispatch(setCustomers(response.data));
      dispatch(setLoading(false));
    } catch (error) {
      dispatch(setError(error.toString()));
      dispatch(setLoading(false));
    }
  }
);

export const searchCustomer = createAsyncThunk(
  "store/searchCustomer",
  async ({ search, page, limit }, { dispatch }) => {
    dispatch(setLoading(true));
    try {
      const response = await apiAxios.get(
        `api/auth/search-customer-data?search=${search}&page=${page}&limit=${limit}`
      );
      dispatch(setCustomers(response.data));
      dispatch(setLoading(false));
      return response.data;
    } catch (error) {
      dispatch(setError(error.toString()));
      dispatch(setLoading(false));
      return error;
    }
  }
);

export const searchCustomerByNumber = createAsyncThunk(
  "store/searchCustomer",
  async (search, { dispatch }) => {
    dispatch(setLoading(true));
    try {
      const response = await apiAxios.get(
        `api/auth/search-customer-data?search=${search}`
      );
      // dispatch(setCustomers(response.data));
      dispatch(setLoading(false));
      return response.data;
    } catch (error) {
      dispatch(setError(error.toString()));
      dispatch(setLoading(false));
      return error;
    }
  }
);

export const savePatientDetails = createAsyncThunk(
  "patient/savePatientDetails",
  async (payload, { dispatch }) => {
    dispatch(setLoading(true));
    try {
      const response = await apiAxios.post("api/auth/save-patient-details", payload);
      dispatch(setLoading(false));
      return response.data;
    } catch (error) {
      dispatch(setError(error.toString()));
      dispatch(setLoading(false));
      throw error;
    }
  }
);
